import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, of, throwError } from 'rxjs';
import { catchError, filter, map, tap } from 'rxjs/operators';
import { FinishHttpLoading, StartHttpLoading } from '../../store/server-communication/server-communication.actions';

@Injectable()
export class SamwinInterceptor implements HttpInterceptor {
   constructor(private store: Store) {}

   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      if (request.url === 'saveInlineUrl' || request.url === 'removeInlineUrl') {
         return of(new HttpResponse({ status: 200 }));
      } else if (request.url === 'saveUrl' || request.url === 'removeUrl') {
         return of(new HttpResponse({ status: 200 }));
      }

      this.store.dispatch(new StartHttpLoading());

      return next.handle(request).pipe(
         tap((x) => this.store.dispatch(new FinishHttpLoading())),
         filter((x) => x instanceof HttpResponse),
         map((x) => x as HttpResponse<any>),
         tap((response: HttpResponse<any>) => {
            console.log(`ResponseStatus for ${response.url} is ${response.statusText} (${response.status})`);
         }),
         catchError((error: HttpErrorResponse) => {
            console.warn(`ResponseStatus for ${error.url} is ${error.statusText} (${error.status})`);
            return throwError(error);
         })
      );
   }
}
